import { useCallback } from 'react';

import { RouteProp, useRoute } from '@react-navigation/native';
import { useFocusEffect } from '@react-navigation/native';

import { Screen } from '@/components/ScreenComponent';
import { useCrossProductClaimFlow } from '@/feature/account-details-sweeps/hooks/use-cross-product-claim-flow';
import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';
import { useActiveProductConfig } from '@/hooks/use-active-product';
import { SweepsLobbyStackParamList } from '@/navigation/sweeps/types';

import { SbkLobbyList } from '../components/SbkLobbyList/SbkLobbyList';

export const SbkLobbyScreen = () => {
    const route = useRoute<RouteProp<SweepsLobbyStackParamList, 'SweepsLobbyScreen'>>();
    const { leagueId, sportId, competitionId } = route.params || {};
    const productConfig = useActiveProductConfig();
    const { enabled: isMaintenanceEnabled } = productConfig?.appMaintenanceConfig?.primary || {};

    useFocusEffect(
        useCallback(() => {
            GASbkEvents.viewLobby();
        }, [])
    );

    useCrossProductClaimFlow();

    return !isMaintenanceEnabled ? (
        <Screen edges={['left', 'right']}>
            <SbkLobbyList leagueId={leagueId} sportId={sportId} competitionId={competitionId} />
        </Screen>
    ) : null;
};
